import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

export const VMS_QUERY_KEYS = {
    nearby: (latitude, longitude, radiusMeters, laneCode) => ["vms-cameras-nearby", latitude, longitude, radiusMeters, laneCode],
    mappable: (latitude, longitude, laneCode) => ["vms-cameras-mappable", latitude, longitude, laneCode],
    cameraPermission: (cameraId, vmsId) => ["vms-camera-permission", vmsId, cameraId],
};

const VmsService = {
    getAll: async () => axios.get(`${API_KEEPER}/vms/config/all`).then(({data}) => data).catch((err) => { throw err }),
    list: async () => axios.get(`${API_KEEPER}/vms/cameras/list`).then(({data}) => data).catch((err) => { throw err }),
    getNearby: async ({latitude, longitude, radiusMeters = 1000, laneCode}) => axios.get(`${API_KEEPER}/vms/cameras/nearby`, {
        params: {latitude, longitude, radiusMeters, laneCode},
    }).then(({data}) => data).catch((err) => { throw err }),
    getMappable: async ({latitude, longitude, laneCode}) => axios.get(`${API_KEEPER}/vms/cameras/map`, {
        params: {latitude, longitude, laneCode},
    }).then(({data}) => data).catch((err) => { throw err }),
    requestCameraPermission: async (cameraId, vmsId) => axios.get(`${API_KEEPER}/vms/camera/permission/${vmsId}`, {
        params: {cameraId},
    }).then(({data}) => data).catch((err) => { throw err }),
    recordersList: async () => axios.get(`${API_KEEPER}/vms/dvr`).then(({data}) => data).catch((err) => { throw err }),
    userBind: async (id, vmsId) => axios.get(`${API_URL}/vms/user-bind/${id}/${vmsId}`).then(({data}) => data).catch((err) => { throw err }),
    userUnbind: async (id, vmsId) => axios.get(`${API_URL}/vms/user-unbind/${id}/${vmsId}`).then(({data}) => data).catch((err) => { throw err }),
    groupsBind: async (form) => axios.post(`${API_KEEPER}/vms/groups/user-bind`, form).then(({data}) => data).catch((err) => { throw err }),
    getAccessGroups: async (search) => axios.get(`${API_KEEPER}/vms/access-groups?groupName=${search}`).then(({data}) => data).catch((err) => { throw err }),
    getVmsConfigurationsByUser: async () => axios.get(`${API_URL}/vms/getVmsConfigurationsByUser`).then(({data}) => data).catch((err) => { throw err }),
    getByIdAndVmsId: async (cameraId, vmsId) => axios.get(`${API_KEEPER}/vms/cameras/byId/${cameraId}/${vmsId}`).then(({data}) => data).catch((err) => { throw err }),
    redirectByCameras: async (vmsId, body) => axios.post(`${API_KEEPER}/vms/redirectByCameras/${vmsId}`, body).then(({data}) => data).catch((err) => { throw err }),
};
export default VmsService;
